export default __webpack_public_path__ + "static/media/wordsinput_locked.206fe806.svg";